import React from 'react';
import BacnetIcon from '../../img/deviceIcons/icon-bacnet';
import IconGroup from '../../img/deviceIcons/icon-group';
import RavenRadonIcon from '../../img/deviceIcons/icon-radon-raven';
import RenewIcon from '../../img/deviceIcons/icon-renew';
import ViewPlusIcon from '../../img/deviceIcons/icon-view-plus';
import WaveEnhanceIcon from '../../img/deviceIcons/icon-wave-enhance';
import WaveNanoIcon from '../../img/deviceIcons/icon-wave-nano';
import HubIcon from '../../img/deviceIcons/new-icon-hub-text_48px';
import WaveMiniIcon from '../../img/deviceIcons/new-icon-mini_48px';
import WaveIcon from '../../img/deviceIcons/new-icon-wave_48px';
import { DeviceTypeNames, VirtualDeviceType } from '../../models/commonEnums';
import { AnyDeviceType } from '../../models/commonTypeScript';

const DeviceIcon = ({ deviceType }: { deviceType: AnyDeviceType }): React.ReactElement => {
    switch (deviceType) {
        case DeviceTypeNames.wave:
        case DeviceTypeNames.wave2:
        case DeviceTypeNames.wavePlus:
        case DeviceTypeNames.waveCo2:
        case DeviceTypeNames.spacePlus:
            return <WaveIcon />;
        case DeviceTypeNames.waveEnhance:
        case DeviceTypeNames.spaceCo2Mini:
            return <WaveEnhanceIcon />;
        case DeviceTypeNames.spaceNano:
            return <WaveNanoIcon />;
        case DeviceTypeNames.mini:
        case DeviceTypeNames.mist:
            return <WaveMiniIcon />;
        case DeviceTypeNames.hub:
        case DeviceTypeNames.spaceHub:
            return <HubIcon />;
        case DeviceTypeNames.viewPlus:
        case DeviceTypeNames.viewRadon:
        case DeviceTypeNames.viewPollution:
        case DeviceTypeNames.viewCo2:
        case DeviceTypeNames.viewPlusBusiness:
            return <ViewPlusIcon />;
        case DeviceTypeNames.bacnet:
            return <BacnetIcon />;
        case VirtualDeviceType.inletAirControl:
        case VirtualDeviceType.aggregatedGroup:
            return <IconGroup />;
        case DeviceTypeNames.ap1:
            return <RenewIcon />;
        case DeviceTypeNames.ravenRadon:
            return <RavenRadonIcon />;
        default:
            return <WaveIcon />;
    }
};

export default DeviceIcon;
